// extracted by mini-css-extract-plugin
module.exports = {"row":"ChatUserPermission_row__3r8fE","cell":"ChatUserPermission_cell__11VMs"};